{
  "welcome": "Welcome",
  "logout": "Logout",
  "login": {
    "title": "Login",
    "username": "Username",
    "password": "Password",
    "button": "Log in"
  },
  "dashboard": {
    "title": "Dashboard",
    "overview": "Overview",
    "settings": "Settings"
  },
  "errors": {
    "404": "Page not found",
    "500": "Internal server error",
    "unexpected": "Unexpected error",
    "somethingWentWrong": "Something went wrong",
    "failedToSaveRole": "Failed to save role",
    "failedToSaveUser": "Failed to save user",
    "failedToLoadRoles": "Failed to load roles",
    "failedToSaveUserRoles": "Failed to save user roles",
    "failedToLoadUsers": "Failed to load users",
    "failedToSaveRoleUsers": "Failed to save role users",
    "passwordRequired": "Password is required",
    "invalidEmailFormat": "Invalid email format"
  },
  "button": {
    "new": "New",
    "edit": "Edit",
    "close": "Close",
    "save": "Save",
    "delete": "Delete",
    "newe": "New",
    "create": "Create",
    "run": "Run",
    "saveAndClose": "Save and Close"
  },
  "key": "Key",
  "action": "Action",
  "search": "Search",
  "name": "Name",
  "port": "Port",
  "encryption": "Encryption",
  "security": "Security",
  "enter": "Enter",
  "menu": {
    "home": "Home",
    "generalConfig": "General Configuration",
    "databaseConnections": "Database connections",
    "flowDefinitions": "Flow Definitions",
    "flowInstances": "Flow Instances",
    "configuration": "Configuration",
    "locks": "Locks",
    "connections": "Connection",
    "tables": "Tables",
    "users": "Users",
    "roles": "Roles"
  },
  "roles": {
    "role": "Role",
    "no-privileges-assigned-to-this-role": "No privileges assigned to this role",
    "assigned": "Assigned",
    "users": "Users",
    "selectUsers": "Select users",
    "searchUsers": "Search users...",
    "noUsersFound": "No users found.",
    "ssoRoleId": "SSO Role ID",
    "filterPrivileges": "Filter Privileges",
    "updatedSuccessfully": "Role updated successfully!",
    "createdSuccessfully": "Role created successfully!"
  },
  "usersForm": {
    "roles": "Roles",
    "selectRoles": "Select roles",
    "searchRoles": "Search roles...",
    "noRolesFound": "No roles found.",
    "updatedSuccessfully": "User updated successfully!",
    "createdSuccessfully": "User created successfully!",
    "privilegesAvailableAfterCreate": "Privileges can be assigned after the user is created."
  },
  "tableView": {
    "useLocalTimezone": "Use local timezone?",
    "refresh": "Refresh",
    "searchAndFilter": "Search & filter"
  },
  "common": {
    "optional": "optional",
    "selfAdminGuardNote": "Saving is blocked if you remove your own admin access.",
    "privileges": "Privileges",
    "assignedSummary": "{{assigned}} of {{total}} assigned",
    "noPrivilegesAvailable": "No privileges available."
  },
  "workflows": {
    "id": "Workflow ID",
    "name": "Message",
    "chosen_option": "Response",
    "overview": "Workflows Overview",
    "parameters": "Variables",
    "original_message": "Original message"
  },
  "select": "Select",
  "general": "General",
  "value": "Value",
  "enter-here": "Enter here",
  "invalid": "Invalid",
  "format": "format",
  "valid": "Valid",
  "execution-status-breakdown": "Execution Status Breakdown",
  "Flow-execution-count-over-time": "Flow Execution Count Over Time",
  "flow-name": "Flow Name",
  "schedule": "Schedule",
  "view-less": "View less",
  "view-all": "View all",
  "next": "Next",
  "previous": "Previous",
  "scheduled-datetime": "Scheduled Datetime",
  "timezone": "Timezone",
  "recurrence": "Recurrence",
  "none": "None",
  "flow-editor": {
    "add-lock": "Add lock",
    "additive": "additive",
    "already-inherited": "already inherited",
    "definition-locks": "Definition locks",
    "definition-locks-help": "These locks come from the referenced node definition.",
    "flow-node-locks": "Flow-node locks",
    "flow-node-locks-additive-help": "Flow-node locks are added to definition locks; they do not replace them.",
    "inherited-read-only": "inherited · read-only",
    "no-locks-left": "No locks left. All available locks are already inherited, selected, or awaiting selection."
  },
  "daily": "Daily",
  "weekly": "Weekly",
  "monthly": "Monthly",
  "yearly": "Yearly",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "select-days-of-the-week": "Select Days of the Week",
  "select-days-of-the-month": "Select Days of the Month",
  "cancel": "Cancel",
  "by": "by",
  "cancel-series": "Cancel Series",
  "cancel-occurrences": "Cancel Occurrences",
  "limit": "Limit",
  "scheduled-start-datetime": "Scheduled start datetime",
  "add-parameter": "Add Parameter",
  "default-value": "Default Value",
  "no-parameters-found": "No parameters found",
  "library": "Library",
  "content": "Content",
  "error-not-authorized": "Not Authorized",
  "empty": "Empty",
  "subject": "Subject",
  "message": "message",
  "all": "All",
  "open": "Open",
  "open-parent-instance": "Open parent instance",
  "closed": "Closed",
  "workflows.no_selected_workflow": "No workflow selected",
  "created_at": "Created at",
  "workflows.last_updated": "Last updated",
  "category": "Category",
  "date": "Date",
  "audit_trail.title": "Audit Trail",
  "audit_trail.created_at": "Date/time",
  "username": "username",
  "user": "user",
  "audit_trail.audit_type": "type",
  "audit_trail.details": "details",
  "items_per_page": "# per page",
  "workflows.response_inputs": "Fields",
  "add-header": "Add Header",
  "base-url": "Base URL",
  "authentication-method": "Authentication Method",
  "grant-type": "Grant Type",
  "callback-url": "Callback URL",
  "authorization-url": "Authorization URL",
  "access-token-url": "Access Token URL",
  "client-id": "Client ID",
  "client-secret": "Client Secret",
  "copy": "Copy",
  "mandatory": "Mandatory",
  "visible": "Visible",
  "evaluate_at_runtime": "Evaluate at runtime",
  "login.mail": "Mail",
  "View and manage your inbox": "View and maintain all workflows in your inbox",
  "View and manage your node instances": "View and maintain all node instances",
  "View and maintain all node definitions": "View and maintain all node definitions",
  "Raise Event": "Raise Event"
}
